import React from 'react';
import { ProductCategory } from '../../types';
import { cn } from '../../utils/cn';
import { useLocalizedTo } from '../../hooks/useLocaleNavigation';

interface CategoryMenuFlatProps {
  categories: ProductCategory[];
  className?: string;
  navLinkClassName?: string;
}

const CategoryMenuFlat: React.FC<CategoryMenuFlatProps> = ({ categories, className, navLinkClassName }) => {
  const localizedTo = useLocalizedTo();
  if (!categories.length) return null;

  return (
    <div className={cn('flex items-center gap-6', className)} data-testid="category-menu-flat">
      {categories.map((category) => (
        <a
          key={category.id}
          href={localizedTo(`/categories/${category.handle}`)}
          className={cn(
            'text-sm text-text-primary no-underline transition-all hover:text-primary whitespace-nowrap border-b-2 border-transparent hover:border-primary pb-1 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
            navLinkClassName
          )}
          data-testid="category-nav-link"
        >
          {category.name}
        </a>
      ))}
    </div>
  );
};

export default CategoryMenuFlat;
